/**
 *
 * Asynchronously loads the component for ParticipantReportsPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
